import Delta from 'quill-delta';
import React, { createContext, useState, useCallback } from 'react';
import { useFileInputContext, useTextInputContext } from '../hooks';
const Context = createContext(undefined);
export const MessageInputContextProvider = ({ children, onSubmit }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showRichTextToolbar, setShowRichTextToolbar] = useState(true);
    const { files, setFiles, setInvalidFiles, uploadProgress, processing } = useFileInputContext();
    const { editor, isEmpty } = useTextInputContext();
    const submit = useCallback(() => {
        if (!editor || (isEmpty && !files.length) || (!!files.length && processing))
            return;
        onSubmit(editor.getContents(), files, editor.getText());
        editor.setContents(new Delta());
        setFiles([]);
        setInvalidFiles([]);
    }, [onSubmit, editor, files, setFiles, uploadProgress, processing, isEmpty]);
    return (React.createElement(Context.Provider, { value: {
            isFocused,
            setIsFocused,
            showRichTextToolbar,
            setShowRichTextToolbar,
            send: submit
        } }, children));
};
export { Context as MessageInputContext };
//# sourceMappingURL=MessageInputContext.js.map